import { useEffect, useMemo, useState } from 'react';

import { getIdTokenPayload, IdTokenClaims } from '$shared/auth/auth-service';

export function useTokenAttributes(tokenAttributes: string[]): Record<string, string> {
  const [claims, setClaims] = useState<IdTokenClaims | null>(null);

  useEffect(() => {
    const fetchSession = async () => {
      try {
        setClaims(await getIdTokenPayload());
      } catch (error) {
        // eslint-disable-next-line no-console -- log for the time being
        console.error('An error occurred fetching the current user session', error);
      }
    };

    fetchSession();
  }, []);

  const attributes = useMemo(() => {
    if (claims) {
      return Object.fromEntries(
        tokenAttributes.map((attribute) => [
          attribute,
          // eslint-disable-next-line security/detect-object-injection -- no user input here
          claims[attribute] as string,
        ]),
      );
    }

    return {};
  }, [claims, tokenAttributes]);

  return attributes;
}
